import { StandardEvents } from '@shopify/events';

class CotigoSymbolVariants extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.generation = 0;
    document.addEventListener(StandardEvents.productSelect, this.onProductSelect, {
      signal: this.controller.signal,
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onProductSelect = async (event) => {
    if (event.target?.closest?.('product-card, dialog')) return;
    const source = event.target?.closest?.('variant-picker');
    if (!source || source.dataset.productId !== this.dataset.productId) return;
    const generation = ++this.generation;
    this.setAttribute('aria-busy', 'true');
    this.hidden = true;
    try {
      const result = await event.promise;
      if (!this.isConnected || generation !== this.generation) return;
      const updated = result?.detail?.html?.querySelector(
        'cotigo-symbol-variants[data-section-id="' + this.dataset.sectionId + '"]'
      );
      if (!updated) return;
      this.innerHTML = updated.innerHTML;
      this.hidden = false;
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('Cotigo symbol update failed', error);
    } finally {
      if (generation === this.generation) this.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('cotigo-symbol-variants')) {
  customElements.define('cotigo-symbol-variants', CotigoSymbolVariants);
}
